import React            from 'react';
import StandaloneButton from '../components/standalone_button';

export default function KioskModeButton({ businessID }) {
  return (
    <div className="kiosk-mode-note">
      <p className="kiosk-mode-note__text">
        Use Kiosk mode to let customers add themselves!
      </p>
      <StandaloneButton label="Kiosk Mode" href={`/${businessID}/contacts/add/kiosk`}/>
    </div>
  );
}
